import React from 'react';
import { Table } from 'reactstrap';

const Events = ({ events }) => {
  return (
    <Table>
      <thead>
        <tr>
          <th />
          <th>Type</th>
          <th>ISIN</th>
          <th>Asset</th>
          <th>Settle. Currency</th>
        </tr>
      </thead>
      <tbody>
        {events.map((item) => (
          <tr key={`sh-evt-${item.id}`}>
            <td>
              <span>
                <i className="fa fa-check" aria-hidden="true"></i>
              </span>
            </td>
            <td>{item.eventType}</td>
            <td>{item.assetISIN}</td>
            <td>{item.assetTicker}</td>
            <td>{item.settleCurrency}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default Events;